__webpack_require__.p = "/apps/atlas-cert-inventory-mfe/";